import { jwtDecode } from 'jwt-decode';
import { axiosAuthClient as axios } from 'services/network/axiosClient';
import * as types from './types';
import domains from 'services/network/global';
import { logError } from 'utils/logs';
const handleTokenError = async (dispatch, verify, auth) => {
    const params = new URLSearchParams(window.location.search);
    let refreshToken = params.get('refresh_token');
    if (!refreshToken) {
        refreshToken = window.localStorage.getItem('auth_refresh');
    }
    if (refreshToken) {
        const { data: dataRefresh } = await axios.post('/auth/refresh_token', { refresh_token: refreshToken });
        if (dataRefresh.status === 'OK') {
            window.sessionStorage.setItem('auth_token', dataRefresh.data.token);
            window.localStorage.setItem('auth_refresh', dataRefresh.data.refresh_token);
            dispatch(verify(auth));
        }
        else if (auth) {
            document.location.assign(`${domains.auth}?redirect=${window.location.href}`);
        }
    }
    else if (auth) {
        document.location.assign(`${domains.auth}?redirect=${window.location.href}`);
    }
};
function verifyToken(auth = true) {
    return async (dispatch) => {
        dispatch({ type: types.FETCH_ROLE_REQUEST, payload: undefined });
        try {
            const token = window.sessionStorage.getItem('auth_token');
            if (!token) {
                await handleTokenError(dispatch, verifyToken, auth);
            }
            else {
                try {
                    const decoded = jwtDecode(token);
                    decoded.iss = Number(decoded.iss);
                    if (Date.now() <= decoded.exp * 1000) {
                        dispatch({
                            type: types.FETCH_ROLE_SUCCEEDED,
                            payload: Object.assign(Object.assign({}, decoded), { token: token }),
                        });
                    }
                    else {
                        await handleTokenError(dispatch, verifyToken, auth);
                    }
                }
                catch (err) {
                    await handleTokenError(dispatch, verifyToken, auth);
                }
            }
        }
        catch (err) {
            logError(err);
            dispatch({ type: types.FETCH_ROLE_FAILED, payload: err });
        }
    };
}
export function isUserAuthorized(usersRoles, necessaryRoles) {
    return necessaryRoles.every((r) => usersRoles.includes(r));
}
export default verifyToken;
